import React, {Component} from 'react';
import MathJax from 'react-mathjax2'

class LatexViewComponent2 extends Component {
    constructor(props){
        super(props)

        this.state = {

        }
    }

    componentDidMount(){
        this.setState({
            text: this.props.text
        })
    }

    /*shouldComponentUpdate(nextProps, nextState){
        if(this.state.text != nextProps.text){
            console.log('updating')
            return true
        }

        return false
    }*/

    render(){
        return(
            <div className = {!this.props.NoBorder ? "border border-info" : ""} style = {{width:this.props.width || '100%', height:this.props.height || '100%', flexDirection:'column', display: 'flex', alignItems:'center', justifyContent:'center' }}>
               
                <MathJax.Context
            input='ascii'
            onLoad = {() => console.log("loaded: " +this.props.text )}
            onError={ (MathJax, error) => {
                console.warn(error);
                console.log("Encountered a MathJax error, re-attempting a typeset!");
                MathJax.Hub.Queue(
                  MathJax.Hub.Typeset()
                );
            } }
            script="https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=AM_HTMLorMML"
            options={ {
                asciimath2jax: {
                     useMathMLspacing: true,
                     delimiters: [["$$","$$"]],
                     preview: "none",
                }
            } }
        >
            <MathJax.Text text={ "$$"+ this.props.text + "$$" }/>
        </MathJax.Context>
            </div>
        )
    }
}

export default LatexViewComponent2